module.exports = __webpack_public_path__ + "img/cjwt.8cafb28b.png";